<template>
	<div>
		<!-- 共享 -->
		<heads></heads>
		<!-- 内容 -->
		<router-view class="bodyBox" id="bodyBox"></router-view>
		<!-- 底部 -->
		<foot></foot>
		
	</div>
</template>

<script>
	import api from "../public/api.js"
	import heads from "../components/head.vue"
	import foot from "../components/foot.vue"
	export default {
		components:{heads,foot},
		data() {
			return {
				userInfo:{}
			}
		},
		created() {
		},
		methods:{
		}
	}
</script>

<style scoped lang="less">
	
	.bodyBox{
		min-height: 90vh;
		background-color: #f3f3f3;
	}
</style>